import React from "react";
import GlyphIcons from "../../../../common/constants/GlyphIcons";
import TooltipIcon from "../../../../layers/component/TooltipIcon";
import { IntlContext, IntlContextProvider } from "../../../../core/core-widgets/contexts/IntlContext";

interface ChangesLoaderProps {
    hidden: boolean;
    disabled: boolean;
    dateOfGeneration: string;
    onClick: (forceReload: boolean) => void;
}

export const ChangesLoader = (props: ChangesLoaderProps) => {
    const { onClick, dateOfGeneration, hidden, disabled } = props;
    if (hidden || !dateOfGeneration) {
        return null;
    }
    return (
        <IntlContextProvider>
            <IntlContext.Consumer>
                {({ intl }) => {
                    return (
                        <>
                            <div>
                                {intl.formatMessage({ id: "workspaceChanges.changesLoader.title" })}{" "}
                                <span className={"utcWarn"}>(UTC)</span>
                            </div>
                            <div>
                                {dateOfGeneration}
                                <button
                                    type={"button"}
                                    className={"no-border btn btn-default refreshButton"}
                                    id={"reloadChangesButton"}
                                    onClick={() => onClick(true)}
                                    disabled={disabled}
                                >
                                    <TooltipIcon
                                        id={"reloadChangesIcon"}
                                        tooltip={intl.formatMessage({
                                            id: "workspaceChanges.changesLoader.reloadChanges",
                                        })}
                                        glyph={GlyphIcons.REFRESH}
                                        className={"reloadChangesIcon"}
                                    />
                                </button>
                            </div>
                        </>
                    );
                }}
            </IntlContext.Consumer>
        </IntlContextProvider>
    );
};
